import { expandedWarrantyTreatmentZodSchema } from "@redotech/redo-model/split";
import { object, string } from "zod";

export const getExpandedWarrantyTreatment = {
  input: object({ desiredTreatmentId: string().optional() }),
  output: object({
    expandedWarrantyTreatment: expandedWarrantyTreatmentZodSchema.optional(),
  }),
};
